import { SeoNavbarAjax } from './seo-navbar.backend-model';
import { SeoNavbar } from './seo-navbar.model';

export function transformSeoNavbar(response: SeoNavbarAjax): SeoNavbar {
  return response;
}
